import { certifications } from '../../mocks/services';

export default function CertificationsScroll() {
  return (
    <>
      <style>{`
        @keyframes scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-scroll {
          animation: scroll 30s linear infinite;
        }
        .animate-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>
      <section className="py-8 sm:py-12 bg-[#f5f5f5] overflow-hidden">
        <div className="flex items-center gap-16 animate-scroll">
          {[...certifications, ...certifications].map((cert, index) => (
            <div key={index} className="flex items-center gap-4 whitespace-nowrap">
              <div className="text-center">
                <div className="font-black text-[#1a1a1a] text-lg">{cert.name}</div>
                <div className="text-gray-600 text-sm">{cert.description}</div>
              </div>
              {index < certifications.length * 2 - 1 && (
                <div className="w-2 h-2 bg-[#FFD700] rounded-full"></div>
              )}
            </div>
          ))}
        </div>
      </section>
    </>
  );
}